import { Injectable } from '@angular/core';
import { AppService } from '@irb/app.service';

@Injectable()
export class AuthService {
  private authToken: string;
  private hasToken: boolean = false;

  constructor(private as: AppService) {}

  setToken(s: string) {
    this.authToken = s;
    this.hasToken = (s) ? true : false;
  }

  getToken(): string {
    return window.atob(this.as.getItem("IRB_AUTH_TOKEN"));
  }

  getTokenExists(): boolean {
    return this.hasToken;
  }
}